import ReactDOM from 'react-dom/client';
import UserPage from './UserPage';
import '../../../../Recoeve/src/main/java/recoeve/db/CDN/recoeve-style.css';
import '../../../../Recoeve/src/main/java/recoeve/db/CDN/user-page-style.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<UserPage />)
